import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import {DeliveryPage} from '../delivery/delivery';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';



@Component({
  selector: 'page-orderplace',
  templateUrl: 'orderplace.html',
   
})

export class OrderPlacePage {

private todo : FormGroup;
private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home' ];

  constructor(public navCtrl: NavController,private formBuilder: FormBuilder) {
	  
	  this.todo = this.formBuilder.group({
		  
		  name:['',Validators.required],
		  mobileno:['',Validators.required],
		  address:['',Validators.required],
		  city:['',Validators.required],
		pincode:['',Validators.required],
		   });
	  }
	  
	  logForm(name,mobileno,address,city,pincode){
		  window.localStorage.setItem('name',name);
		  window.localStorage.setItem('mobileno',mobileno);
		  window.localStorage.setItem('address',address);
		  window.localStorage.setItem('city',city);
		  window.localStorage.setItem('pincode',pincode);
		  this.navCtrl.push(DeliveryPage);
	  }
   
 _keyPress(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
  
  if(this.specialKeys.indexOf(event.key) !== -1)
  {
   return;
      // invalid character, prevent input
   
    }
 //alert('Enter The Number');
      event.preventDefault();
 }
}

_button(event:any) {
	
	const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
if (!pattern.test(inputChar)) {
  
  if(this.specialKeys.indexOf(event.key) !== -1)
  {
   return;
      // invalid character, prevent input
   
    }
 //alert('Enter The Number');
      event.preventDefault();
 }
	
}

  
        
}



// WEBPACK FOOTER //
// ./src/pages/orderplace/orderplace.ts